const CHUNK_RELOAD_KEY = "rabo-chunk-reload";

export function isChunkLoadError(error) {
  if (!error) return false;
  const message = error.message || String(error);
  return error.name === "ChunkLoadError" || /Loading chunk .* failed/i.test(message);
}

export function installChunkLoadRecovery() {
  const reloadOnce = () => {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
    window.location.reload();
    return true;
  };

  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadError(event.reason)) return;
    event.preventDefault();
    reloadOnce();
  });

  window.addEventListener(
    "error",
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLScriptElement)) return;
      if (!target.src || !target.src.includes("/static/js/")) return;
      event.preventDefault();
      reloadOnce();
    },
    true
  );
}

export function lazyWithRetry(importFn) {
  return importFn().catch((error) => {
    if (!isChunkLoadError(error)) {
      throw error;
    }
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
      return new Promise(() => {});
    }
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    throw error;
  });
}
